export const formatPrice = (price: string | number) => {
  const str = String(price);
  const fixValue = 2;

  // If it contains a decimal
  if (str.includes('.')) {
    const [, decimals] = str.split('.');

    // Case: exactly 1 decimal → pad to 2
    if (decimals?.length === 1) {
      return Number(price).toFixed(fixValue); // "39.90"
    }

    // Case: 2+ decimals → keep exactly as given
    return str;
  }

  // No decimals → return as is
  return str;
};
